"use strict";
import * as dom from "./lib/dom.js";
import { tns } from "tiny-slider";

export default function () {
    const slide = document.querySelector(".o-que-fazemos-slide__container");
    if (slide) {
        const QsSlide = tns({
            container: ".o-que-fazemos-slide__container",
            loop: true,
            items: 1,
            slideBy: "page",
            controls: false,
            navPosition: "bottom",
            touch: true,
            mouseDrag: true,
            gutter: 12,
        });
    }
}
